/* eslint-disable no-useless-escape */
import moment from 'moment'
import objectDefaultValue from '@/config/object.env'

import excelDataModel from '@/models/general/excelData.model'

const changeTypeData = {
    async checkRequired(input) {
        if (input === undefined || input === null || !input.toString()) {
            return false;
        }
        return true;
    },

    async containsSQLInjection(input) {

        // /[-'";\(\)\{\}\[\]]/,
        //Các mẫu phổ biến của SQL injection
        const sqlInjectionPatterns = [
            /(\b(ALTER|CREATE|DELETE|DROP|EXEC(UTE)?|INSERT( +INTO)?|SELECT|UPDATE)\b)|(\b(UNION( +ALL)?)\b)/i,
            /(\b(CONCAT|GROUP_CONCAT|LENGTH|SUBSTRING|IFNULL|IF\s*?\())/i,
        ];

        //Kiểm tra chuỗi với từng mẫu
        for (const pattern of sqlInjectionPatterns) {
            if (pattern.test(input)) {
                return true; //Chuỗi có chứa mẫu SQL injection
            }
        }

        return false; //Chuỗi an toàn
    },

    async fromDatetoString(input) {

        if (!input) {
            return null
        }

        // Kiểm tra nếu giá trị không phải là đối tượng Date
        if (!(input instanceof Date)) {
            return null
        }


        let day = null
        let month = null

        if (input.getDate() >= 10) {
            day = "" + (input.getDate())
        }
        else {
            day = "0" + (input.getDate())
        }

        if (input.getMonth() + 1 >= 10) {
            month = "" + (input.getMonth() + 1)
        }
        else {
            month = "0" + (input.getMonth() + 1)
        }
        return day + "/" + month + "/" + input.getFullYear();
    },

    async checkNumberNull(input, required) {
        if (input === undefined || input == '') {
            return required ? 0 : null
        }
        else return input
    },

    async parseBoolean(str) {
        if (str === "true") {
            return true;
        } else if (str === "false") {
            return false;
        } else {
            return null;
        }
    },

    fromStringtoDate(dString) {
        var newDateTime = moment(dString, "DD/MM/YYYY").toDate();
        return newDateTime != 'Invalid Date' ? newDateTime : null;
    },

    async fromExcelNumbertoDate(input) {
        const millisecondsPerDay = 24 * 60 * 60 * 1000; // Số mili giây trong một ngày
        const excelEpochDiff = 25569; // Số ngày từ 1/1/1900 đến 1/1/1970
        const timezoneOffset = 7 * 60; // Độ chênh lệch múi giờ (7 giờ)

        const excelTimestamp = (input - excelEpochDiff) * millisecondsPerDay;
        const gmtTimestamp = excelTimestamp - (timezoneOffset * 60 * 1000);
        return new Date(gmtTimestamp);
    }
}

const correctData = {
    async handleStringImport(input, required) {
        let returnModel = Object()
        if (required) {
            if (!await changeTypeData.checkRequired(input)) {
                returnModel =
                {
                    value: "",
                    isError: true,
                    error: "Dữ liệu bắt buộc",
                }
                return returnModel
            }
        }
        if (!input) {
            returnModel =
            {
                value: "",
                isError: false,
                error: null,
            }
            return returnModel
        }
        if (await changeTypeData.containsSQLInjection(input)) {
            returnModel =
            {
                value: input.toString(),
                isError: true,
                error: "Chuỗi chứa dữ liệu không phù hợp",
            }
            return returnModel
        }

        returnModel =
        {
            value: input.toString(),
            isError: false,
            error: null,
        }
        return returnModel

    },

    async handleBooleanImport(input, required) {
        let returnModel = Object()

        //Kiểm tra dữ liệu có REQUIRED hay không?
        if (required) {
            if(input === undefined){
                returnModel =
                {
                    value: "",
                    isError: true,
                    error: "Dữ liệu bắt buộc",
                }
                return returnModel
            }
            const stringValue = input + ""
            if (!await changeTypeData.checkRequired(stringValue)) {
                returnModel =
                {
                    value: "",
                    isError: true,
                    error: "Dữ liệu bắt buộc",
                }
                return returnModel
            }
        }

        //Kiểm tra dữ liệu không REQUIRED và rỗng
        if (input == undefined) {
            returnModel =
            {
                value: "",
                isError: false,
                error: null,
            }
            return returnModel
        }

        //Kiểm tra tính đúng đắn dữ liệu
        //Dữ liệu có giá trị 0,1 hoặc nhận giá trị true hoặc false
        if (typeof input === 'boolean') {
            switch (input) {
                case true:
                    returnModel =
                    {
                        value: "TRUE",
                        isError: false,
                        error: null,
                    }
                    return returnModel
                case false:
                    returnModel =
                    {
                        value: "FALSE",
                        isError: false,
                        error: null,
                    }
                    return returnModel
                default:
                    returnModel =
                    {
                        value: input.toString(),
                        isError: true,
                        error: "Dữ liệu không phù hợp",
                    }
                    return returnModel
            }
        }
        //Dữ liệu thuộc chuỗi String
        let stringInput = input.toString().toUpperCase();
        if (stringInput == "TRUE" || input.toString() == "1") {
            returnModel =
            {
                value: "TRUE",
                isError: false,
                error: null,
            }
            return returnModel
        }
        if (stringInput == "FALSE" || input.toString() == "0") {
            returnModel =
            {
                value: "FALSE",
                isError: false,
                error: null,
            }
            return returnModel
        }


        returnModel =
        {
            value: input.toString(),
            isError: true,
            error: "Dữ liệu không phù hợp",
        }
        return returnModel

    },

    async handleIntImport(input, required) {
        let returnModel = Object()
        if (required && (!await changeTypeData.checkRequired(input))) {
            returnModel =
            {
                value: "",
                isError: true,
                error: "Dữ liệu bắt buộc",
            }
            return returnModel
        }
        if (input == undefined) {
            returnModel =
            {
                value: "",
                isError: false,
                error: null,
            }
            return returnModel
        }
        const isNumber = /^[0-9]*$/.test(input)
        if (!isNumber) {
            returnModel =
            {
                value: input.toString(),
                isError: true,
                error: "Dữ liệu không phù hợp",
            }
            return returnModel
        }
        returnModel =
        {
            value: input.toString(),
            isError: false,
            error: null,
        }
        return returnModel
    },

    async handleSmallIntImport(input, required) {
        let returnModel = Object()
        if (required && (!await changeTypeData.checkRequired(input))) {
            returnModel =
            {
                value: "",
                isError: true,
                error: "Dữ liệu bắt buộc",
            }
            return returnModel
        }
        if (input == undefined) {
            returnModel =
            {
                value: "",
                isError: false,
                error: null,
            }
            return returnModel
        }
        if (!Number.isInteger(input)) {
            returnModel =
            {
                value: input.toString(),
                isError: true,
                error: "Dữ liệu không phù hợp",
            }
            return returnModel
        }
        else {
            let val = parseInt(input);
            if (val > 32767) {
                returnModel =
                {
                    value: input.toString(),
                    isError: true,
                    error: "Giá trị quá lớn",
                }
                return returnModel
            }
        }

        returnModel =
        {
            value: input.toString(),
            isError: false,
            error: null,
        }
        return returnModel
    },

    async handleTinyIntImport(input, required) {
        let returnModel = Object()
        if (required && (!await changeTypeData.checkRequired(input.toString()))) {
            returnModel =
            {
                value: "",
                isError: true,
                error: "Dữ liệu bắt buộc",
            }
            return returnModel
        }
        if (input == undefined) {
            returnModel =
            {
                value: "",
                isError: false,
                error: null,
            }
            return returnModel
        }
        if (!Number.isInteger(input.toString())) {
            returnModel =
            {
                value: input.toString(),
                isError: true,
                error: "Dữ liệu không phù hợp",
            }
            return returnModel
        }
        else {
            let val = parseInt(input);
            if (val > 127) {
                returnModel =
                {
                    value: input.toString(),
                    isError: true,
                    error: "Giá trị quá lớn",
                }
                return returnModel
            }
        }

        returnModel =
        {
            value: input.toString(),
            isError: false,
            error: null,
        }
        return returnModel
    },

    async handleNumberImport(input, required) {
        let returnModel = Object()
        if (required) {
            if (!await changeTypeData.checkRequired(input)) {
                returnModel =
                {
                    value: input.toString(),
                    isError: true,
                    error: "Dữ liệu bắt buộc",
                }
                return returnModel
            }
        }
        if (input == undefined) {
            returnModel =
            {
                value: "",
                isError: false,
                error: null,
            }
            return returnModel
        }
        const isNumber = /^[0-9]+(\.[0-9]+)?$/.test(input)

        if (!isNumber) {
            returnModel =
            {
                value: input.toString(),
                isError: true,
                error: "Dữ liệu không phù hợp",
            }
            return returnModel
        }
        returnModel =
        {
            value: input.toString(),
            isError: false,
            error: null,
        }
        return returnModel

    },

    async handleDateImport(input, required) {
        let returnModel = Object()
        if (required) {
            if (!changeTypeData.checkRequired(input)) {
                returnModel =
                {
                    value: input.toString(),
                    isError: true,
                    error: "Dữ liệu bắt buộc",
                }
                return returnModel
            }
        }
        if (!input) {
            returnModel =
            {
                value: "",
                isError: false,
                error: null,
            }
            return returnModel
        }
        else {
            let parseValue = parseInt(input);
            if (typeof input != "number") {
                var newDateTime = moment(input, "DD/MM/YYYY").toDate();
                if (isNaN(newDateTime)) {
                    returnModel =
                    {
                        value: input.toString(),
                        isError: true,
                        error: "Dữ liệu không phù hợp",
                    }
                    return returnModel
                }
                else {
                    returnModel =
                    {
                        value: await changeTypeData.fromDatetoString(newDateTime),
                        isError: false,
                        error: null,
                    }
                    return returnModel
                }
            }

            else {
                const millisecondsPerDay = 24 * 60 * 60 * 1000; // Số mili giây trong một ngày
                const excelEpochDiff = 25569; // Số ngày từ 1/1/1900 đến 1/1/1970
                const timezoneOffset = 7 * 60; // Độ chênh lệch múi giờ (7 giờ)

                const excelTimestamp = (input - excelEpochDiff) * millisecondsPerDay;
                const gmtTimestamp = excelTimestamp - (timezoneOffset * 60 * 1000);
                let value = new Date(gmtTimestamp);
                returnModel =
                {
                    value: await changeTypeData.fromDatetoString(value),
                    isError: false,
                    error: null,
                }
                return returnModel
            }
        }
    },

    async handleOnlyRequiredImport(input) {
        let returnModel = Object()
        if (!changeTypeData.checkRequired(input)) {
            returnModel =
            {
                value: "",
                isError: true,
                error: "Dữ liệu bắt buộc",
            }
            return returnModel
        }
        else {
            returnModel =
            {
                value: "",
                isError: false,
                error: null,
            }
            return returnModel
        }
    }


}

const showData = {
    async showNumber(value) {
        let temp = await value ? new Intl.NumberFormat('vi-VN', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 10,
        }).format(value) : value;
        return temp;
    }
}

const formatData = {
    async aFileToSend(input) {
        let returnModel = {
            file: null,
            isDeleted: null,
        }
        if (input.typeSend == objectDefaultValue.NAVIGATECODE_VALUE.CREATE) {
            if (input.files && input.files.length > 0) {
                returnModel.file = input.files[0]
            }
            else returnModel.file = null
        }
        else if (input.typeSend == objectDefaultValue.NAVIGATECODE_VALUE.UPDATE) {
            if (input.nameOldFile) {
                //Có sẵn file
                if (input.files && input.files.length > 0) {
                    returnModel.file = (input.files && input.files.length > 0) ? null : input.files[0]
                    returnModel.isDeleted = (input.files && input.files.length > 0) ? false : true
                }
                else {
                    //Xóa file
                    returnModel.file = null
                    returnModel.isDeleted = true
                }
            }
            else {
                //Không có file
                returnModel.file = (input.files && input.files.length > 0) ? input.files[0] : null
            }
        }
        return returnModel

    }
}

const actions = {
    async handleTypeImport({ dispatch }, { input, typeData, required }) {
        if (typeData == objectDefaultValue.handleData.REQUIRED_ONLY)
            return await correctData.handleOnlyRequiredImport(input);
        if (typeData == objectDefaultValue.handleData.STRING)
            return await correctData.handleStringImport(input, required);
        if (typeData == objectDefaultValue.handleData.BOOLEAN)
            return await correctData.handleBooleanImport(input, required);
        if (typeData == objectDefaultValue.handleData.TINYINT)
            return await correctData.handleTinyIntImport(input, required);
        if (typeData == objectDefaultValue.handleData.SMALLINT)
            return await correctData.handleSmallIntImport(input, required);
        if (typeData == objectDefaultValue.handleData.INT)
            return await correctData.handleIntImport(input, required);
        if (typeData == objectDefaultValue.handleData.NUMBER)
            return await correctData.handleNumberImport(input, required);
        if (typeData == objectDefaultValue.handleData.DATE)
            return await correctData.handleDateImport(input, required);
    },


    async handleChangeType({ dispatch }, { input, typeChange }) {
        if (typeChange == objectDefaultValue.changeTypeData.DATE_TO_STRING)
            return await changeTypeData.fromDatetoString(input);

        if (typeChange == objectDefaultValue.changeTypeData.STRING_TO_DATE)
            return await changeTypeData.fromStringtoDate(input);

        if (typeChange == objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL)
            return await changeTypeData.checkNumberNull(input, false);

        if (typeChange == objectDefaultValue.changeTypeData.CHECK_NUMBER_NULL_REQUIRED)
            return await changeTypeData.checkNumberNull(input, true);
        if (typeChange == objectDefaultValue.changeTypeData.STRING_TO_BOOLEAN)
            return await changeTypeData.parseBoolean(input);
    },

    async showData({ dispatch }, { input, typeShow }) {
        if (typeShow == 'Number')
            return showData.showNumber(input);
    },

    async formatData({ dispatch }, { input, typeFormat }) {
        formatData
        if (typeFormat == 'aFileToSend')
            return formatData.aFileToSend(input);
    }





}

export const handleData2 = {
    namespaced: true,
    actions,
};
